(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["searoomlynn_basic_item"] && !Shopify.designMode) return;
  try {
    
 var basic = new Swiper('#section-basicitems .swiper-container', {
  navigation: {
    nextEl: '#section-basicitems .swiper-button-next',
    prevEl: '#section-basicitems .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  pagination: {
    el: '#section-basicitems .swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 3,
      slidesPerGroup: 3,
      allowTouchMove: false,
      spaceBetween: 30,
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_featured_collection"] && !Shopify.designMode) return;
  try {
    
  var featured = new Swiper('#section-featured .swiper-container', {
  navigation: {
    nextEl: '#section-featured .swiper-button-next',
    prevEl: '#section-featured .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 0,
  loop: false,
  pagination: {
    el: '#section-featured .swiper-pagination',
    clickable: true,
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_findby_category"] && !Shopify.designMode) return;
  try {
    
  var ranking = new Swiper('#section-category .swiper-container', {
  navigation: {
    nextEl: '#section-category .swiper-button-next',
    prevEl: '#section-category .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  pagination: {
    el: '#section-category .swiper-pagination',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 5,
      slidesPerGroup: 5,
      allowTouchMove: false,
      spaceBetween: 20,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_newarrival"] && !Shopify.designMode) return;
  try {
    
  var newarrival = new Swiper('#section-newarrival .swiper-container', {
  navigation: {
    nextEl: '#section-newarrival .swiper-button-next',
    prevEl: '#section-newarrival .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  pagination: {
    el: '#section-newarrival .swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 3,
      slidesPerGroup: 3,
      allowTouchMove: false,
      spaceBetween: 24,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_news"] && !Shopify.designMode) return;
  try {
    
  var news = new Swiper('#section-news .swiper-container', {
  navigation: {
    nextEl: '#section-news .swiper-button-next',
    prevEl: '#section-news .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  pagination: {
    el: '#section-news .swiper-pagination',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      allowTouchMove: false,
      spaceBetween: 24,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_pickup_item"] && !Shopify.designMode) return;
  try {
    
  var pickupitem = new Swiper('#section-pickupitem .swiper-container', {
  navigation: {
    nextEl: '#section-pickupitem .swiper-button-next',
    prevEl: '#section-pickupitem .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  pagination: {
    el: '#section-pickupitem .swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 3,
      slidesPerGroup: 3,
      allowTouchMove: false,
      spaceBetween: 24,
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_ranking"] && !Shopify.designMode) return;
  try {
    
  var ranking = new Swiper('#section-ranking .swiper-container', {
  navigation: {
    nextEl: '#section-ranking .swiper-button-next',
    prevEl: '#section-ranking .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  pagination: {
    el: '#section-ranking .swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 5,
      slidesPerGroup: 5,
      allowTouchMove: false,
      spaceBetween: 20,
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_recommend_item"] && !Shopify.designMode) return;
  try {
    
  var recommend = new Swiper('#section-recommend_item .swiper-container', {
  navigation: {
    nextEl: '#section-recommend_item .swiper-button-next',
    prevEl: '#section-recommend_item .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 0,
  loop: false,
  pagination: {
    el: '#section-recommend_item .swiper-pagination',
    type: 'progressbar',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_shoplist_page"] && !Shopify.designMode) return;
  try {
    
  var shoplist = new Swiper('#shoplist_page .swiper-container', {
  speed: 1500,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  allowTouchMove: true,
  slidesPerView: 1.2,
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 1
    }
  },
  pagination: {
    el: '#shoplist_page .swiper-pagination',
    type: 'progressbar'
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_the_look"] && !Shopify.designMode) return;
  try {
    

var shopify_section_thelook_pc = new Swiper('#section-thelook .pc .swiper-container', {
  navigation: {
    nextEl: '#section-thelook .pc .swiper-button-next',
    prevEl: '#section-thelook .pc .swiper-button-prev'
  },
  speed: 500,
  slidesPerView: 4.5,
  slidesPerGroup: 1,
  spaceBetween: 0,
  loop: true,
  centeredSlides: true
});
var section_thelook_sp = new Swiper('#section-thelook .sp .swiper-container', {
  navigation: {
    nextEl: '#section-thelook .sp .swiper-button-next',
    prevEl: '#section-thelook .sp .swiper-button-prev'
  },
  pagination: {
    el: "#section-thelook .sp .swiper-pagination",
    type: "fraction",
    formatFractionCurrent: function (number) {
      if ( number < 10 ) {
      return '0' + number;
      }
    },
    formatFractionTotal: function (number) {
      if ( number < 10 ) {
      return '0' + number;
    }
  }
  }, 
  speed: 500,
  slidesPerView: 1,
  slidesPerGroup: 1,
});

  } catch(e) { console.error(e); }
})();
})();
